import { Component, OnInit, Input, ViewChild, inject } from '@angular/core';
import { UsersApi, ApiPaymentSource } from 'api';
import { FormInput, PageComponent, FormComponent } from '@tytapp/common';
import { Validated, CreditCardValidator, ExpirationDateValidator, CVCValidator, NonEmptyValidator, CreditCardService, OptionalFutureDateValidator } from 'validation';
import { CreateStripeTokenResponse, StripeService } from 'stripe';

@Component({
  selector: 'credit-card-selector',
  templateUrl: './credit-card-selector.component.html',
  styleUrls: ['./credit-card-selector.component.scss']
})
export class CreditCardSelectorComponent extends PageComponent implements OnInit {
  private usersApi = inject(UsersApi);
  private stripe = inject(StripeService);
  private creditCards = inject(CreditCardService);

  submit() {
    // No op.
  }

  @Input() 
  newCardMessage : string = null;

  @Validated({ class: NonEmptyValidator, field: 'cardholder-name' })
  @FormInput()
  cardholderName: string = "";

  @Validated({ class: CreditCardValidator, field: 'cc-number' })
  @FormInput()
  creditCard: string = "";

  @Validated({ class: ExpirationDateValidator, field: 'cc-exp' })
  @FormInput()
  expiration: string = "";

  @Validated({ class: OptionalFutureDateValidator, field: 'deliver-at' })
  @FormInput()
  deliverAt : string = "";

  @Validated({ class: CVCValidator, field: 'cc-csc' })
  @FormInput()
  cvc: string = "";

  paymentSource: ApiPaymentSource;

  inputNewCard = false;
  cardBrand : string = null;
  cardBrandIcon : string = null;

  @Input()
  validityError: boolean;

  async init() {
    try {
      this.paymentSource = await this.usersApi.getPaymentSource().toPromise();
    }
    catch(e) {
      console.log('error: ', e);
      this.inputNewCard = true;
    }
  }

  @ViewChild('form')
  form: FormComponent;

  isValid() {
    if (this.inputNewCard)
      return this.form.validate();

    if (this.paymentSource)
      return true;

    return false;
  }

  async getSource() {
    let response: CreateStripeTokenResponse;
    if (this.inputNewCard) {
      // stripe token
      if (!this.form.validate()) {
        return undefined;
      }
      try {
        response = await this.stripe.createToken({ name: this.cardholderName, number: this.creditCard, exp: this.expiration, cvc: this.cvc });
      } catch (e) {
        this.showError(e.message || e.error);
        return undefined;
      }

      if (response.response.error && response.response.error.message) {
        this.showError(response.response.error.message);
        return undefined;
      }
      let token = response.response.id;
      return token;
    }

    if (this.paymentSource) {
      return this.paymentSource.card_id;
    }
  }

  async updateCardBrand() {
    setTimeout(() => {
      let cardStr = this.creditCard;
      let cardInfo = this.creditCards.getInfo(cardStr);
      this.cardBrand = cardInfo && cardInfo.card ? cardInfo.card.type : null;

      this.cardBrandIcon = {
        'visa': 'cc-visa',
        'master-card': 'cc-mastercard',
        'discover': 'cc-discover',
        'american-express': 'cc-amex',
        'jcb': 'cc-jcb',
        'diners-club': 'cc-diners-club',
      }[this.cardBrand];
    }, 100);
  }


}
